type Props = {
  nombre: string;
  descripcion: string;
  precio: string;
  imagen: string;
};

const CardProducto = ({ nombre, descripcion, precio, imagen }: Props) => {
  return (
    <div className="producto-card">
      <img src={imagen} alt={nombre} />
      <h2>{nombre}</h2>
      <p>{descripcion}</p>
      <p className="precio">{precio}</p>
    </div>
  );
};

export default CardProducto;
